import { string, object, oneOfType, shape, func } from 'prop-types'
import { ImageColumnContainer, ActionsWrapper } from './tile-image-column.styled'
import Link from '../link'
import AdditionalLabels from './tile-additional-labels'
import Colors from './tile-colors'
import ActionWishList from '../action-wish-list'
import { HoverImageWrapper } from './tile.styled'
import React, { useState } from 'react'
import ProductImage from '../../particles/product-image'
import Video from '../../particles/video'
import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import { useTheme } from '@mui/system'
import useMediaQuery from '@mui/material/useMediaQuery'
import ActionAddToCart from '../action-add-to-cart'

const ImageColumn = ({
	url,
	imageProps,
	hoverImageProps,
	videoProps,
	wishListProps,
	additionalLabelsProps,
	colorsProps,
	onClick,
	addToCartProps,
}) => {
	const [showHoverImage, setShowHoverImage] = useState(false)

	const theme = useTheme()
	const mdUp = useMediaQuery(theme.breakpoints.up('md'))

	return (
		<ImageColumnContainer
			onMouseOver={() => {
				if (mdUp) {
					setShowHoverImage(true)
				}
			}}
		>
			<Link href={url} onClick={onClick}>
				{videoProps ? (
					<Video
						url={videoProps.src.match(/https|http:\/\//)?.length > 0 ? videoProps.src : mediaUrl(videoProps.src)}
						originalWidth={videoProps.originalWidth}
						originalHeight={videoProps.originalHeight}
						autoplay
						startOnEveryInView
						stopOnEveryOutView
						controls={false}
						loop
						playIcon={null}
						thresholdInView={0.35}
						{...videoProps}
					/>
				) : (
					<>
						{/* eslint-disable-next-line jsx-a11y/alt-text */}
						<ProductImage {...imageProps} />
						{hoverImageProps?.src && mdUp && (
							<HoverImageWrapper
								className={showHoverImage ? 'active' : null}
								onMouseLeave={() => setShowHoverImage(false)}
							>
								{/* eslint-disable-next-line jsx-a11y/alt-text */}
								<ProductImage {...hoverImageProps} />
							</HoverImageWrapper>
						)}
					</>
				)}
				{additionalLabelsProps && <AdditionalLabels {...additionalLabelsProps} />}
			</Link>
			{((wishListProps && wishListProps.position === 'inner') ||
				(addToCartProps && addToCartProps.position === 'inner')) && (
				<ActionsWrapper>
					{wishListProps && wishListProps.position === 'inner' && <ActionWishList {...wishListProps} />}
					{addToCartProps && addToCartProps.position === 'inner' && <ActionAddToCart {...addToCartProps} />}
				</ActionsWrapper>
			)}
			{colorsProps && colorsProps.position === 'inner' && (
				<Colors
					position={colorsProps.position}
					expanded={colorsProps.expanded}
					label={colorsProps.label}
					colors={colorsProps.colors}
					onClick={colorsProps.onClickColor}
					onHover={colorsProps.onHoverColor}
				/>
			)}
		</ImageColumnContainer>
	)
}

ImageColumn.propTypes = {
	url: oneOfType([string, object]),
	imageProps: shape(ProductImage.propTypes),
	hoverImageProps: shape(ProductImage.propTypes),
	wishListProps: object,
	additionalLabelsProps: object,
	colorsProps: object,
	onClick: func,
}

export default ImageColumn
